import { useQuery } from '@tanstack/react-query';

import { standbyActiveEntryQuery } from '@/api/standby/standbyActiveEntryQuery';
import { useHasSession } from '@/hooks/auth/useHasSession';

import type { UseStandbyActiveEntryQueryOptions } from './types';

export const useStandbyActiveEntryQuery = (
  shopId: string,
  customerId: string,
  options?: UseStandbyActiveEntryQueryOptions,
) => {
  const hasSession = useHasSession();

  return useQuery({
    ...standbyActiveEntryQuery(shopId, customerId),
    ...options,
    // A caller's `enabled` must never re-open the factory's required-id
    // guard — matches useStandbyStylistsQuery/useStandbyPublicShopQuery.
    enabled:
      !!shopId && !!customerId && hasSession && (options?.enabled ?? true),
  });
};
